import { NavLink, useLocation } from "react-router-dom";

function LanguageSwitcher({ newLang, icon, className }) {
  const location = useLocation();

  // Split the pathname
  const pathParts = location.pathname.split("/").filter(Boolean); // ['en', 'about']
  const restPath = pathParts.slice(1).join("/"); // 'about'

  const newPath = `/${newLang}/${restPath}`;

  return (
    <NavLink to={newPath} className={className}>
      {icon}
    </NavLink>
  );
}

export default LanguageSwitcher;
